import { getFormValue } from 'app/services/businessFunctionHelpers';
import { FieldsEnum } from 'app/shared/enums';

export function getConsentsValues() {
  const mainConsentValue = getFormValue(FieldsEnum.InsuranceMarketingConsent);
  const contactConsentValue = getFormValue(FieldsEnum.InsuranceContactConsent);
  const mainEmailConsentValue = getFormValue(
    FieldsEnum.InsuranceMarketingEmailConsent
  );
  const regulationsConsentValue = getFormValue(FieldsEnum.ConsentRegulations);
  const cepikConsentValue = getFormValue(FieldsEnum.ConsentCepik);

  return {
    cepikConsentValue,
    mainConsentValue,
    contactConsentValue,
    mainEmailConsentValue,
    regulationsConsentValue,
  };
}
